import type { EmbeddedSignupLoginOptions } from './embeddedSignupOptions';

export interface MetaLoginResponse {
  authResponse?: { code?: string };
  status?: string;
}

export interface EmbeddedSignupSdk {
  login: (
    callback: (response: MetaLoginResponse) => void,
    options: EmbeddedSignupLoginOptions
  ) => void;
}

export interface EmbeddedSignupPopupObservation {
  popup: Window | null;
  popupCreated: boolean;
  target: string | null;
}

export const invokeEmbeddedSignupLogin = (
  sdk: EmbeddedSignupSdk,
  callback: (response: MetaLoginResponse) => void,
  options: EmbeddedSignupLoginOptions,
  onPopup?: (observation: EmbeddedSignupPopupObservation) => void
): Window | null => {
  const originalWindowOpen = window.open;
  let capturedPopup: Window | null = null;

  window.open = function (...args) {
    const popup = originalWindowOpen.apply(window, args);
    capturedPopup = popup;
    onPopup?.({
      popup,
      popupCreated: Boolean(popup),
      target: typeof args[1] === 'string' ? args[1] : null,
    });
    return popup;
  };

  try {
    sdk.login(callback, options);
    return capturedPopup;
  } finally {
    window.open = originalWindowOpen;
  }
};
